import { render, staticRenderFns } from "./EtalonList.vue?vue&type=template&id=287da710"
import script from "./EtalonList.vue?vue&type=script&lang=js"
export * from "./EtalonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports